class LuxPremiumCollection {
  #filterPanel;
  #filterToggle;
  #filterClose;
  #backdrop;
  #globalSwitch;

  constructor() {
    this.#filterPanel  = document.getElementById('lux-filters-panel');
    this.#filterToggle = document.getElementById('lux-filter-toggle');
    this.#filterClose  = document.getElementById('lux-filter-close');
    this.#backdrop     = document.getElementById('lux-backdrop');
    this.#globalSwitch = document.getElementById('lux-global-switch-input');

    this.#initFilters();
    this.#initFilterGroups();
    this.#initFilterAutoSubmit();
    this.#initSort();
    this.#initImageSwitches();
    this.#initGlobalSwitch();
  }

  // ── Filter drawer ────────────────────────────────────────────
  #initFilters() {
    this.#filterToggle?.addEventListener('click', () => this.#openFilters());
    this.#filterClose?.addEventListener('click',  () => this.#closeFilters());
    this.#backdrop?.addEventListener('click',     () => this.#closeFilters());
  }

  #openFilters() {
    this.#filterPanel?.classList.add('lux-filters--open');
    if (this.#backdrop) this.#backdrop.hidden = false;
    this.#filterToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('lux-no-scroll');
  }

  #closeFilters() {
    this.#filterPanel?.classList.remove('lux-filters--open');
    if (this.#backdrop) this.#backdrop.hidden = true;
    this.#filterToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('lux-no-scroll');
  }

  // ── Filter group collapse / expand ──────────────────────────
  #initFilterGroups() {
    document.querySelectorAll('.lux-filter-group__title').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.lux-filter-group');
        const open  = group.classList.toggle('lux-filter-group--open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  // ── Filter checkbox auto-submit ──────────────────────────────
  #initFilterAutoSubmit() {
    document.querySelectorAll('#lux-filter-form input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', () => {
        document.getElementById('lux-filter-form')?.submit();
      });
    });
  }

  // ── Sort select ─────────────────────────────────────────────
  #initSort() {
    document.getElementById('lux-sort-select')?.addEventListener('change', () => {
      document.getElementById('lux-filter-form')?.submit();
    });
  }

  // ── Per-card image switch ────────────────────────────────────
  #initImageSwitches() {
    document.querySelectorAll('.lux-product-card__switch-input').forEach(input => {
      this.#applyCardState(input);
      input.addEventListener('change', () => this.#applyCardState(input));
    });
  }

  #applyCardState(input) {
    input.closest('.lux-product-card')
      ?.classList.toggle('lux-product-card--lights-off', !input.checked);
  }

  // ── Global ON/OFF switch ─────────────────────────────────────
  #initGlobalSwitch() {
    this.#globalSwitch?.addEventListener('change', () => {
      const on = this.#globalSwitch.checked;
      document.querySelectorAll('.lux-product-card__switch-input').forEach(input => {
        input.checked = on;
        this.#applyCardState(input);
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new LuxPremiumCollection());
